import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const LinkValue = ({ valueLinkText, valueLinkUrl }) => (
  <span>
    {valueLinkText} <Link to={valueLinkUrl}>here</Link>
  </span>
);

LinkValue.propTypes = {
  valueLinkText: PropTypes.string.isRequired,
  valueLinkUrl: PropTypes.string.isRequired,
};

export default LinkValue;
